export function BootstrapScreen({ phase = 'connecting', attempt = 1, onRetry, onPlayOffline }) {
  const offline = phase === 'offline';
  const copy = offline
    ? 'The street server is not answering right now. Your account data has not been changed.'
    : attempt > 1
      ? 'Still checking the street. Temporary connection problems are retried automatically.'
      : 'Restoring your session and checking the street…';

  return (
    <main className="bootstrap-shell" aria-busy={!offline}>
      <section className="bootstrap-card" aria-labelledby="bootstrap-title">
        <div className="bootstrap-logo-wrap">
          <img src="./branding/the-dope-man-logo.webp" alt="The Dope Man" />
        </div>
        <div className="bootstrap-kicker">THE DOPE MAN · UI v2</div>
        <h1 id="bootstrap-title">{offline ? 'Connection unavailable' : 'Loading the street'}</h1>
        <p>{copy}</p>
        {!offline && (
          <div className="bootstrap-progress" role="status" aria-live="polite">
            <span className="bootstrap-spinner" aria-hidden="true" />
            <strong>{attempt > 1 ? `Retrying connection · ${attempt}` : 'Connecting securely…'}</strong>
          </div>
        )}
        {offline && (
          <div className="bootstrap-actions">
            <button className="btn buy" type="button" onClick={onRetry}>Retry</button>
            <button className="btn sell" type="button" onClick={onPlayOffline}>Play Offline Classic</button>
          </div>
        )}
        <small>Authentication and saved-run checks happen in the background. Sensitive connection details are never displayed here.</small>
      </section>
    </main>
  );
}
